var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('CampaignBody',{attrs:{"campaigns":_vm.campaigns,"isCampaigns":_vm.isCampaigns,"user":_vm.user,"isUsd":_vm.isUsd,"usdValue":_vm.usdValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }